import 'swiper/swiper-bundle.min.css';
import 'swiper/components/effect-fade/effect-fade.min.css';
import "./src/styles/global.css";
